import React, { ReactElement } from 'react';

import classNames from 'classnames';

import { CARD_CLASS } from '../../utils/constants';
import * as Styled from './Card.styles';
import { ICardProps } from './Card.types';
import CardBar from './components/CardBar/CardBar';

const Card = ({ className = '', header, padding = 'medium', children, footer, ...rest }: ICardProps): ReactElement => (
  <Styled.Card className={classNames(CARD_CLASS, className)} {...rest}>
    {header && <CardBar bar={header} type="header" padding={padding} />}
    <Styled.CardBody padding={typeof children === 'string' ? padding : 'none'}>{children}</Styled.CardBody>
    {footer && <CardBar bar={footer} type="footer" padding={padding} />}
  </Styled.Card>
);

export default Card;
